import { useEffect, useState } from 'react';
import axios from 'axios';

function pickDefaultSeason(seasons = []) {
  if (!seasons.length) return null;
  const today = new Date();

  return (
    seasons.find((season) => {
      const start = new Date(season.start_date);
      const end = new Date(season.end_date);
      return season.registration_open || (start <= today && end >= today);
    }) || seasons[0]
  );
}

function useGetActiveLeague() {
  const [state, setState] = useState({
    activeLeague: null,
    activeSeason: null,
    registrationSeason: null,
  });

  useEffect(() => {
    // Fetch active leagues
    axios.get('/api/leagues/active-leagues/', {
      withCredentials: true,
    })
      .then(response => {
        // Set the first league as the default active league if none is selected
        if (response.data.length > 0) {
          const defaultLeague = response.data[0];
          const defaultSeason = pickDefaultSeason(defaultLeague.seasons);

          // Batch both updates in a single state change
          setState({
            activeLeague: defaultLeague,
            activeSeason: defaultSeason,
            registrationSeason: null,
          });
        }
      })
      .catch(error => {
        console.error('Error fetching leagues:', error);
      });
  }, []); // Empty dependency array - only run once on mount

  useEffect(() => {
    if (!state.activeLeague?.id) {
      setState(prev => ({ ...prev, registrationSeason: null }));
      return;
    }

    let isMounted = true;

    axios.get('/api/leagues/seasons/open_registrations/', {
      params: { league_id: state.activeLeague.id },
      withCredentials: true,
    })
      .then((response) => {
        if (!isMounted) return;
        const openSeasons = Array.isArray(response.data) ? response.data : [];
        setState(prev => ({
          ...prev,
          registrationSeason: openSeasons[0] || null,
        }));
      })
      .catch((error) => {
        console.error('Error fetching registration season:', error);
        if (isMounted) {
          setState(prev => ({ ...prev, registrationSeason: null }));
        }
      });

    return () => {
      isMounted = false;
    };
  }, [state.activeLeague?.id]);

  const setActiveLeague = (league) => {
    const defaultSeason = pickDefaultSeason(league?.seasons || []);
    setState(prev => ({
      ...prev,
      activeLeague: league,
      activeSeason: defaultSeason,
      registrationSeason: null,
    }));
  };

  const setActiveSeason = (season) => {
    setState(prev => ({ ...prev, activeSeason: season }));
  };

  return {
    activeLeague: state.activeLeague,
    setActiveLeague,
    activeSeason: state.activeSeason,
    setActiveSeason,
    registrationSeason: state.registrationSeason,
  };
}

export default useGetActiveLeague;
